module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/verify-account/verify-account.component.scss
// module id = ./src/app/verify-account/verify-account.component.scss
// module chunks = main